import { z } from 'zod'
import { furnitureItemDtoSchema } from './furniture-item.dto.js'

/** How much of one catalog item a venue space stocks. */
export const spaceInventoryEntryDtoSchema = z.object({
  furnitureItemId: z.string().uuid(),
  item: furnitureItemDtoSchema,
  quantity: z.number().int().nonnegative(),
})

export type SpaceInventoryEntryDto = z.infer<typeof spaceInventoryEntryDtoSchema>
